import { Dispatch, Reducer } from "redux";
import { DropdownItemProps } from "semantic-ui-react";
import { GET_USERS } from "../actions/usersActions";
import { getUsersAsProps } from "../services/userService";

export interface UsersState extends DropdownItemProps {}

const initialState: UsersState[] = [];

export const usersReducer: Reducer<UsersState[]> = (
    state: UsersState[] = initialState,
    action: any
): UsersState[] => {
    switch (action.type) {
        case GET_USERS:
            return action.payload;
        default:
            return state;
    }
};

export async function fetchUsers(dispatch: Dispatch) {
    const res = await getUsersAsProps();
    dispatch({ type: "GET_USERS", payload: res });
}
